import React from 'react';
import { Container } from './styles';

interface Props {
    onChange: (date) => void;
}

const FormData: React.FC<Props> = ({ onChange }) => {


    return <Container>
        <input
            type='datetime-local'
            className='dateTime'
            onChange={(e) => {
                onChange(e.currentTarget.value)
            }}
        />
    </Container>
}

export default FormData;